import store from '@/store/store';
import ApiService from '@/services/api.service';
import { CONNECT } from '@/app.config';

const SceneService = {
  /**
   * Añade una nueva escena a una instalación
   *
   * @param {Object} data - Datos de la escena
   * @returns {String} - Id de la escena creada
   */
  async addScene(data) {
    const { installationID, scene } = data;

    // Request
    if (store.getters['globalModule/isDemo']) {
      return new Date().getUTCMilliseconds();
    }

    const resource = `installations/scene/${installationID}/${CONNECT.SCOPE}`;
    const response = await ApiService.post(resource, scene);

    return response.data;
  },

  /**
   * Edita una escena de una instalación
   *
   * @param {Object} data - Datos de la escena
   * @returns {String} - Id de la escena editada
   */
  async editScene(data) {
    const { installationID, sceneID, scene } = data;

    // Request
    if (!store.getters['globalModule/isDemo']) {
      const resource = `installations/scene/${installationID}/${sceneID}/${CONNECT.SCOPE}`;
      await ApiService.patch(resource, scene);
    }

    return sceneID;
  },

  /**
   * Elimina una escena de una instalación
   *
   * @param {Object} data - Datos de la escena
   * @returns {String} - Id de la escena eliminada
   */
  async deleteScene(data) {
    const { installationID, sceneID } = data;

    // Request
    if (!store.getters['globalModule/isDemo']) {
      const resource = `installations/scene/${installationID}/${sceneID}/${CONNECT.SCOPE}`;
      await ApiService.delete(resource);
    }

    return sceneID;
  },

  /**
   * Ejecuta una escena de una instalación
   *
   * @param {Object} data - Datos de la escena
   * @returns {String} - Id de la escena ejecutada
   */
  async launchScene(data) {
    const { installationID, sceneID } = data;

    // Request
    if (!store.getters['globalModule/isDemo']) {
      const resource = `installations/scene/${installationID}/${sceneID}/${CONNECT.SCOPE}`;
      await ApiService.put(resource);
    }

    return sceneID;
  },
};

export default SceneService;
